import styled from 'styled-components';
import { mobileWidth } from '~/constants/metrics';

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: ${mobileWidth}) {
    flex-direction: column;
    align-items: flex-end;
  }
`;
